import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { connect } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { ImprimirFactura } from "./ImprimirFactura";
import { ImprimirTiquete } from "./ImprimirTiquete";
import { getDireccionReceptor, getDireccionEmisor, duplicarFactura } from "../../actions/index";
import { tipoImpresionEnum } from "../../enum";
import { ValidarLogin } from '../../util';
import { useHistory } from "react-router-dom";

const ImprimirDocumento = (props) => {

    const { token } = ValidarLogin(props);
    const {
        duplicarFacturaState,
        getDireccionEmisor,
        getDireccionReceptor,
        direccionReceptorState,
        direccionEmisorState
    } = props;
    const componentRef = useRef();
    const { tipo } = useParams();
    const [tipoImpresion] = useState(tipo);
    const [imprimir, setImprimir] = useState(false);
    const history = useHistory();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current.click(),
    });

    useEffect(() => {
        if (duplicarFacturaState === null) {
            history.push(`/facturas`);
        }
        if (token !== null && duplicarFacturaState !== null) {
            getDireccionEmisor(duplicarFacturaState.Emisor.Id, token.access_token);
            getDireccionReceptor(duplicarFacturaState?.Receptor?.Id, token.access_token);
        }
        return () => {
            props.duplicarFactura(null);
        }
    }, [duplicarFacturaState]);

    useEffect(() => {
        if (direccionEmisorState !== null) {
            setImprimir(true);
            const interval = setInterval(() => {
                document.getElementById("yourbutton")?.click();
                clearInterval(interval);
            }, 500)
            const intervalClose = setInterval(() => {
                history.push(`/facturas`);
                clearInterval(intervalClose);
            }, 1500)
        }
        
    }, [direccionEmisorState, direccionReceptorState]);

    return (

        <div>
            {

                imprimir &&
                (
                    <div>
                        <ReactToPrint
                            trigger={() => <button id="yourbutton" className="ui button" style={{visibility: "hidden"}} >Start clicking</button>}
                            content={() => componentRef.current}
                        />

                        <div>
                            {
                                (tipoImpresion === tipoImpresionEnum.Tiquete) ?
                                    <ImprimirTiquete ref={componentRef} data={duplicarFacturaState} onClick={handlePrint} direccionReceptorState={direccionReceptorState} direccionEmisorState={direccionEmisorState} /> :
                                    <ImprimirFactura ref={componentRef} data={duplicarFacturaState} onClick={handlePrint} direccionReceptorState={direccionReceptorState} direccionEmisorState={direccionEmisorState} />
                            }
                        </div>

                    </div>
                )

            }

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loginState: state.loginState,
        duplicarFacturaState: state.duplicarFacturaState,
        direccionReceptorState: state.direccionReceptorState,
        direccionEmisorState: state.direccionEmisorState,
    };
};

export default connect(mapStateToProps, {
    getDireccionReceptor,
    getDireccionEmisor, duplicarFactura,
    duplicarFactura
})(ImprimirDocumento);
